import { useState } from "react";

import { Container, Stack } from "@mui/material";

import { cmpBaseColors } from "../../cmpBaseColors";
import { useCustomerId } from "../../Components/hooks/useCustomerId";
import { useDarkThemeCheck } from "../../Components/hooks/useDarkThemeCheck";
import { UpgradeOptions } from "../Upsell/UpgradeOptions";
import { CloudflowFAQ, CloudFlowOverview } from "./CloudflowDasboard/CloudflowDefaultState";
import { useTrackCloudflowEvent } from "./hooks";
import NavatticSection from "./NavatticSection";

const LandingPage = () => {
  const isDarkMode = useDarkThemeCheck();
  const track = useTrackCloudflowEvent();
  const customerId = useCustomerId();

  const [showUpgradeOptions, setShowUpgradeOptions] = useState(false);

  return (
    <>
      <Container maxWidth="lg" sx={{ pb: 2, pt: 4 }}>
        <CloudFlowOverview
          onShowUpgradeOptions={() => {
            setShowUpgradeOptions(true);
            track("Upsell Button Clicked", { customerId });
          }}
        />
        <NavatticSection />
      </Container>
      <Stack
        mx={-2}
        justifyContent="center"
        sx={{
          backgroundColor: isDarkMode ? cmpBaseColors.backgroundDark : cmpBaseColors.backgroundLight,
        }}
      >
        <Container maxWidth="lg" sx={{ px: 2 }}>
          <CloudflowFAQ />
        </Container>
      </Stack>
      <UpgradeOptions
        featureName="Cloudflow"
        open={showUpgradeOptions}
        onClose={() => {
          setShowUpgradeOptions(false);
        }}
        sendUpsellEvent={() => {
          track("Upsell Submitted", {
            customerId,
          });
        }}
      />
    </>
  );
};

export default LandingPage;
